// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controls-settings-tablecell-keylist {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.controls-settings-table {
  border-spacing: 0;
  width: 100%;
}

.controls-settings-table td {
  vertical-align: top;
  padding: calc(var(--input-element-gap) / 2) var(--input-element-gap);
}

.controls-settings-tablerow-alt {
  background-color: #f0f0f0;
}

.controls-settings-tablecell-trigger {
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
}

.controls-settings-emulate-button {
  width: fit-content;
  margin: 4px 0;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/options-dialog/controls-settings/ControlsSettings.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".controls-settings-tablecell-keylist {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.controls-settings-table {\n  border-spacing: 0;\n  width: 100%;\n}\n\n.controls-settings-table td {\n  vertical-align: top;\n  padding: calc(var(--input-element-gap) / 2) var(--input-element-gap);\n}\n\n.controls-settings-tablerow-alt {\n  background-color: #f0f0f0;\n}\n\n.controls-settings-tablecell-trigger {\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n}\n\n.controls-settings-emulate-button {\n  width: fit-content;\n  margin: 4px 0;\n  padding: 0 10px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
